<template lang="pug">
include ../pug/svg
section#dashbaord
	p(v-if="viaSignin") Welcome back {{user.firstName}}!
	div.fieldset
		p.empty(v-if="!filteredNotifications.length") No pending notifications.
		template(v-else)
			div#ctrl
				div
					h4 Notifications
					//-Search(v-model:search="search")
					template(vif="typeFilters.length > 1")
						Filter(id="type" label="Type" title="Type" :options="typeFilters" v-model:selected="typeFilter")
						Filter(v-if="typeFilter" id="subtype" label="Subtype" title="Subtype" :options="subtypeFilters" v-model:selected="subtypeFilter")
			ul.list
				li.notification.counter(v-for="(notification, index) in filteredNotifications" :key="notification.id" :notification="notification" :index="index")
					div.hgroup(:data-num="notification.data.ids.length")
						h2 {{subject(notification.data.subject)}}
						//-h3 {{formatDate(notification.createdAt)}} 
					div.butmore
						AppLink(:to="{name:notification.data.view, query:{ids:notification.data.ids.join()}}") {{notification.data.cta}}
						button.but(type="button" aria-haspopup="true" aria-controls="" @mouseenter="showTint(),setMenu($event)" @mouseleave="hideTint") More
							+svg(svg-filename="iconMore" aria-hidden="true" alt="More icon")
						nav.menu(@mouseenter="showTint" @mouseleave="hideTint")
							div.bar
								+svg(svg-filename="iconMore" aria-hidden="true")
								button.but(type="button") Close
									+svg(svg-filename="iconClose")
							ul
								li
									a(@click="dismissNotification(notification)") Dismiss
</template>

<script>
import Filter from '../components/Filter';
import Search from '../components/Search';

export default {
	name: 'Dashboard',
	components: {
		Search,
		Filter,
	},
	data() {
		return {
			show: true,
			search: null,
			typeFilter: null,
			subtypeFilter: null,
			notificationTypes: [
				{
					option: 'Course',
					value: 'course',
					subTypes: [
						{
							option: 'Created',
							value: 'created',
						},						
					],
				},
				{
					option: 'User',
					value: 'user',
					subTypes: [],
				},
			],
		}
	},
	mounted() {		
		this.$store.dispatch('gui/setHeader', {
			title: 'Dashboard',
			backRoute: {
				text: 'Signout',
				name: 'Signin',
				params: {
					signout: true
				},
			},
		});
		
		this.refreshNotifications();
	},
	computed: {
		user() {
			return this.$store.state.auth.user;
		},		
		notifications() {
			return this.$store.state.auth.notifications;
		},
		typeFilters() {
			return this.notificationTypes.map(n => {
				return {
					option: n.option,
					value: n.value,
				};
			});
		},
		subtypeFilters() {
			return this.typeFilter ? this.notificationTypes.find(n => n.value === this.typeFilter.value).subTypes : [];
		},
		filteredNotifications() {
			return this.notifications;
		},
		viaSignin() {
			const prevUrl = this.$router.options.history.state.back;
			
			if (!prevUrl) {
				return false;
			}
			
			const prevRoute = this.$router.resolve({ path: prevUrl });
			
			if (!prevRoute) {
				return false;
			}
			
			return (prevRoute.name === 'Signin');
		},
	},
	methods: {
		async dismissNotification(notification) {
			await this.$store.dispatch('auth/dismissNotification', notification.id);
		},
		async refreshNotifications() {
			// load notifications from db
			await this.$store.dispatch('auth/dbNotifications');
		},
		subject(subject) {
			return subject.replace(/^[\d\s]*/, '');
		},
		showTint() {
			this.$store.dispatch('gui/setTintState', true);
		},
		hideTint() {
			this.$store.dispatch('gui/setTintState', false);
		},
		setMenu(event) {
			if (event.target.nodeName === 'BUTTON' && event.relatedTarget.nodeName !== 'NAV') {
				const menu = event.target.nextSibling;
				menu.classList.remove('reverse');				
				const rect = menu.getBoundingClientRect();
				
				if (rect.bottom > window.innerHeight) {
					menu.classList.add('reverse');
				}
			}
		},
		formatDate(isoDate) {
			const date = new Date(isoDate);
			return date.toLocaleString('en-GB', {
				timeZone:'UTC',
				month:'short',
				year: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
	},
}
</script>

<style lang="scss">
#dashbaord {
	.wrapper {
		width: 100%;
	}
	.fieldset {
		max-width: 800px;
		padding-bottom: 20px;
		h4 {
			margin-bottom: 0;
		}
		#ctrl {
			margin-top: 0;
			div {
				align-items: center;
				padding: 0 !important;
				h4 {
					width: auto;
				}
			}
		}
		p.empty {
			color: var(--pan-lnk-dis);
		}
		ul {
			width: 100%;
		}
	}
	li.notification {
		padding-right: 20px;
		.hgroup {
			h2 {
				&:first-letter {
					text-transform: capitalize;
				}
				&:only-child {
					margin-bottom: 0;
				}
			}
		}
		.butmore {
			>* {
				transform: translateX(0);
			}
		}
	}
}
/*
.fadey-enter-active, .fadey-leave-active {
	transition: opacity 1s;
}
.fadey-enter, .fadey-leave-to {
	opacity: 0;
}
*/
</style>
